export default function ManualTable({ data }) {
  var fieldArray = [];
  //   for (const dataIn in data) {
  let tempArray = [];
  data.column.map(
    (p) => tempArray.push(p.field) // console.log(p.field + " : " + dataIn)
  );
  fieldArray.push(tempArray);
  //   }
  return (
    <table className="mainCont">
      <thead className={"header-space"}>
        <td colspan={4} className={"tdStyleHead"} >
        </td>
      </thead>
      {/**/}
      <tbody>
        <>
          {/*{tabledata.column.map(p => array.push(p.field))}*/}
          {/*<td></td>*/}

          {/*<td></td>*/}
          <tr>
            {data.column.map((p) => (
              <th>{p.title}</th>
            ))}
          </tr>
          {data.data.map((key) => (
            <tr>
              {fieldArray[0].map((input) => (
                <td>{key[input]}</td>
              ))}
            </tr>
          ))}
        </>
      </tbody>
      {/**/}

      <tfoot className={"footer-space"}>
        <td colspan={4} className={"tdStyleHead"}></td>
      </tfoot>
    </table>
  );
}
